var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('b-spinner',{attrs:{"type":"grow"}}):_c('div',_vm._l((_vm.relationLabel()),function(relation){return _c('b-badge',{key:relation,staticClass:"p-1 m-1 relation",attrs:{"variant":"dark"}},[_vm._v(" "+_vm._s(relation)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }